import * as AseguradoRepository from "../../services/repositories/asegurado-repository";
import * as Constantes from '../../utils/constantes'
import * as ContratanteRepository from "../../services/repositories/contratante-repository";
import * as FamiliarRepository from "../../services/repositories/familiar-repository";
import * as FirmaRepository from "../../services/repositories/firma-repository";
import * as Funciones from '../../utils/funciones'
import * as GeneralActions from '../../store/actions/generalActions'
import * as GeneralRepository from "../../services/repositories/general-repository";
import * as SolicitudMultipleRepository from "../../services/repositories/solicitud-multiple-repository";

import React, { useContext, useEffect, useState } from "react"
import { obtenerPagosSolicitud, registrarPagos } from '../../services/repositories/primer-pago-repository'

import Footer from "../../components/Footer"
import GeneralContext from "../../context/GeneralContext"
import Header from "../../components/Header"
import Modal from "../../components/Modals"
import dedoArriba from '../../img/vinetadedoarriba.png'
import modeloFirma from "../../img/pantallaFirma.jpg"
import styles from "./Firma.module.css"

const Firma = ({ history }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]
    
    const initialState = {
        estaCargando: true,
        errorCargando: null,
        reloadValidacionModal: false,
        reloadFirmaEmail: false,
        reloadValidacionCard: false,
        contratante: null,
        asegurado: null,
        emailContratanteInicial: null,
        emailAseguradoInicial: null,
        textoError: [],
        estado: {
            mostrarCard: false
        },
        campoValidado: {
            emailA: true,
            emailC: true,
            emailM: true
        },
        codigoEstado: null,
        noBloqueo: false,
        esAseguradoAdicional: false,
        aseguradoAdicional: null
    }

    const [state, setState] = useState(initialState)
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrar, setMostrar] = useState(false)

    const [mostrarMensajes, setMostrarMensajes] = useState(false)
    const [mensajes, setMensajes] = useState([])
    const [enabledPrimerPago, setEnabledPrimerPago] = useState(false)
    const obtenerContratante = async () => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const response = await ContratanteRepository.obtenerContratante(cotizacion.idSolicitudMultiple)
        if(response.error === null) {
            const responseEstado = await SolicitudMultipleRepository.obtenerEstadoSolicitudMultiple(cotizacion.idSolicitudMultiple)
            if(responseEstado.error === null) {
                setState((state) => {
                    return {
                        ...state,
                        codigoEstado: responseEstado.estado.codigo,
                        estadoFirma: responseEstado.estado.estadoFirma
                    }
                })
            } else {
                generalDispatch(GeneralActions.updateError(responseEstado.error, '¡Alerta!'))
            }

            if (cotizacion.firmaValidada || (responseEstado.estado.codigo === 2 || responseEstado.estado.codigo === 6
                || responseEstado.estado.codigo === 8 || responseEstado.estado.codigo === 12)) {

                if (responseEstado.estado.estadoFirma === 6) {
                    setMostrarModal(true)
                }

                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                        contratante: response.contratante,
                        asegurado: cotizacion && cotizacion.asegurado,
                        /*emailContratanteInicial: response.contratante !== null && response.contratante.contacto !== undefined
                            ? response.contratante.contacto.email : null,
                        emailAseguradoInicial: cotizacion && cotizacion.asegurado !== null && cotizacion.asegurado.contacto !== undefined
                            ? cotizacion.asegurado.contacto.email : null*/
                    }
                })
            } else {
                setMostrarModal(true)
                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                        contratante: response.contratante,
                        asegurado: cotizacion && cotizacion.asegurado,
                        /*emailContratanteInicial: response.contratante !== null && response.contratante.contacto !== undefined
                            ? response.contratante.contacto.email : null,
                        emailAseguradoInicial: cotizacion && cotizacion.asegurado !== null && cotizacion.asegurado.contacto !== undefined
                            ? cotizacion.asegurado.contacto.email : null*/
                    }
                })
            }
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }

        let esAseguradoAdicional = false
        cotizacion.solicitudes.map(solicitud => {
            esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
        })

        if(esAseguradoAdicional){
            const response = await FamiliarRepository.obtenerFamiliares(cotizacion.idSolicitudMultiple)
            if(response.error === null) {
                setState((state) => {
                    return {
                      ...state,
                      aseguradoAdicional: response.familiares.filter((item) => item.indicadorAseguradoAdicional === 1)[0]
                    }
                })
            }
        }

        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }

    const getPaymentsSolicitud = async (producto) => {
        const response = await obtenerPagosSolicitud(cotizacion.idSolicitudMultiple)
        if (response.error) {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        } 
        setEnabledPrimerPago(response.pagos.some(pago => pago.cobranzaPrimeraCuota.codigo))
    }

    useEffect(() => {
        obtenerContratante()
        flagEsAseguradoAdicional()
        getPaymentsSolicitud()
    }, [])

    const flagEsAseguradoAdicional = async () => {
        let esAseguradoAdicional = false
        cotizacion.solicitudes.map(solicitud => {
            esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
        })
        setState((state) => {
            return {
                ...state,
                esAseguradoAdicional: esAseguradoAdicional
            }
        })
    }
   const hasProductVidaInversionCapital = cotizacion.productos.filter(producto => producto.codigoProducto === Constantes.COD_PRODUCTO_VIDA_INVERSION_CAPITAL).length > 0

    const handlePrimerPago = async () => {

        const bodyPrimerPago = cotizacion.solicitudes.map(solicitudes => ({
            cobranzaPrimeraCuota: {
                codigo: Constantes.COD_COBRANZA_DIRECTA,
                descripcion:""
            },
            codigoSafetyPay: "",
            entidadPrimeraCuota: {
                codigo: Constantes.COD_ENTIDAD_PRIMERA_CUOTA,
                descripcion:""
            },
            externalId: null,
            fechaPago: Funciones.getCurrentFormattedDate(),
            fechaVencimientoSafetyPay: Constantes.DEFAULT_DATE,
            idSolicitud: solicitudes.idSolicitud,
            numerooperacionTarjeta: null,
            pagoLink:"",
            usuario: user.info.IdUsuario
        }));

        const putPago = await registrarPagos(bodyPrimerPago, cotizacion.idSolicitudMultiple)
        if (putPago.error) {
            generalDispatch(GeneralActions.updateError(putPago.error, '¡Alerta!', true))
                
        } 
        history.push('/prospectoFinal')
    }

    const invocarPostFirma = async (metodoPin) => {
        const response = await FirmaRepository.registrarFirma(cotizacion.idSolicitudMultiple, metodoPin, user.info.IdUsuario)
        if(response.error === null) {
            setState((state) => {
                return {
                    ...state,
                    reloadValidacionCard: true,
                    reloadFirmaEmail: false
                }
            })
            if(hasProductVidaInversionCapital){
                handlePrimerPago()
            }
            else{
                history.push('/primerPago')
            }
        } else {
            if (response.error.codigoRespuesta === 403) {
                let error = {
                    ...response.error,
                    mensajeRespuesta: response.error.mensajeRespuesta.slice(23)
                }
                generalDispatch(GeneralActions.updateError(error, '¡Alerta!'))
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            }
            return false
        }
    }

    const validarPersonID = async () => {
        const response = await GeneralRepository.validarPersonID(cotizacion.idSolicitudMultiple, cotizacion.solicitudes)
        if(response.error === null) {
            return true
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            return false
        }
    }

    const invocarPutContratante = async (emailContratante) => {
        const response = await ContratanteRepository.guardarContratante({
            ...state.contratante,
            contacto: {
                ...state.contratante.contacto,
                email: emailContratante
            },
            adjuntos: null,
            usuario: user.info.IdUsuario
        }, 'firma')
        if(response.error === null) {
            setState((state) => {
                return {
                    ...state,
                    reloadValidacionModal: false,
                    estado: {
                        ...state.estado,
                        mostrarCard: true
                    }
                }
            })
            generalDispatch(GeneralActions.updateCorreoContratante(emailContratante))
            if (!state.noBloqueo) {
                if (response.contratante.mensaje === "") {
                    return true
                } else {
                    setMensajes(['¡Alerta!', response.contratante.mensaje])
                    setMostrarMensajes(true)
                    setState((state) => {
                        return {
                            ...state,
                            noBloqueo: true
                        }
                    })
                    return false
                }
            } else {
                return true
            }
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            return false
        }
    }

    const invocarPutAseguradoAdicional = async () => {
        let aseguradoAdicionalAuxPut = {}

        aseguradoAdicionalAuxPut = {
            ...state.aseguradoAdicional,
            usuario: user.info.IdUsuario
        }

        const response = await FamiliarRepository.guardarFamiliarAdicional(cotizacion.idSolicitudMultiple, aseguradoAdicionalAuxPut)
        if(response.error === null) {
            return true
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            return false
        }
    }

    const invocarPutAsegurado = async (emailAsegurado, emailContratante) => {
        const response = await AseguradoRepository.guardarAsegurado({
            ...state.asegurado,
            contacto: {
                ...state.asegurado.contacto,
                email: emailAsegurado
            },
            adjuntos: null,
            usuario: user.info.IdUsuario,
            idSolicitudMultiple: cotizacion.idSolicitudMultiple
        }, 'firma')
        if(response.error === null) {
            generalDispatch(GeneralActions.updateCorreoAsegurado(emailAsegurado))
            if (!state.noBloqueo) {
                if (response.asegurado.mensaje === "") {
                    return await invocarPutContratante(emailContratante)
                } else {
                    setMensajes(['¡Alerta!', response.asegurado.mensaje])
                    setMostrarMensajes(true)
                    setState((state) => {
                        return {
                            ...state,
                            noBloqueo: true
                        }
                    })
                    return false
                }
            } else {
                return await invocarPutContratante(emailContratante)
            }
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            return false
        }
    }


    const validarPantalla = async () => {
        //Invocacion al servicio de firma/encolar si es que el codigo de estado es 1
       if (state.codigoEstado === Constantes.CODIGO_VALIDACION_FIRMA_EN_PROCESO) {
           let pasar = await invocarPostFirma(Constantes.METODO_PAGO_PIN_EMAIL)
           if (pasar) {
               let validacionPersonID = await validarPersonID()
               if(validacionPersonID) {
                   generalDispatch(GeneralActions.updateEstadoProspecto())
                   generalDispatch(GeneralActions.updateEstadoFirma())
                   return true
               }
           }
           return false
       }
       else if(state.codigoEstado !== Constantes.CODIGO_VALIDACION_FIRMA_EN_PROCESO){
         if(hasProductVidaInversionCapital && !enabledPrimerPago){
         handlePrimerPago()
         return;
          }
         if(hasProductVidaInversionCapital && enabledPrimerPago){
         generalDispatch(GeneralActions.continuarProceso(history.location.pathname))
         history.push('/prospectoFinal')
         return;
          }
         
        history.push('/primerPago')
        return
       }
       else {
        history.push('/primerPago')
       }
    }

    const validarPantallaModal = async () => {
        let validado = true
        const asignarValidacionCampo = (campo, valor) => {
            validado = validado && valor
            setState((state) => {
                return {
                    ...state,
                    campoValidado: {
                        ...state.campoValidado,
                        [campo]: valor
                    }
                }
            })
        }

        const validarTexto = (objeto, campoValidacion, campo) => {
            if (objeto === null || objeto[campo] === undefined ||
                objeto[campo] === '' || !Funciones.esEmailValido(objeto[campo])) {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        if (cotizacion.esDistintoAsegurado) {
            validarTexto(state.asegurado.contacto, 'emailA', 'email')
            validarTexto(state.contratante.contacto, 'emailC', 'email')
            if(state.asegurado.contacto.email === state.contratante.contacto.email) {
                asignarValidacionCampo('emailCA', false)
            } else {
                asignarValidacionCampo('emailCA', true)
            }
        } else if(state.esAseguradoAdicional) {    
            validarTexto(state.contratante.contacto, 'emailC', 'email')
            validarTexto(state.aseguradoAdicional, 'emailM', 'correoElectronico')
            if(state.aseguradoAdicional.correoElectronico === state.contratante.contacto.email) {
                asignarValidacionCampo('emailCM', false)
            } else {
                asignarValidacionCampo('emailCM', true)
            }
        } else {
            validarTexto(state.contratante.contacto, 'emailC', 'email')
        }

        if (validado) {
            //Invocar actualizacion de correos
            let salida
            if (cotizacion.esDistintoAsegurado) {
                salida = await invocarPutAsegurado(state.asegurado.contacto.email, state.contratante.contacto.email)
            } else if (state.esAseguradoAdicional) {
                salida = await invocarPutAsegurado(state.contratante.contacto.email, state.contratante.contacto.email) && await invocarPutAseguradoAdicional()
            } else {
                salida = await invocarPutAsegurado(state.contratante.contacto.email, state.contratante.contacto.email)
            }

            if (salida) {
                if(state.estadoFirma == Constantes.ESTADO_FIRMA_CORREO_ERRADO){
                    await encolarSolicitud()
                }
                setMostrarModal(false)
            }
        }
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }

    const encolarSolicitud = async () => {
        const response = await FirmaRepository.registrarFirma(cotizacion.idSolicitudMultiple, Constantes.METODO_PAGO_PIN_EMAIL, user.info.IdUsuario)
        if (response.error === null) {
            setMostrarModal(false)
            return true
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
            return false
        }
    }
    return (
        <React.Fragment>
            <Header history={history} valor={cotizacion.requisitosIniciales !== undefined
                && cotizacion.requisitosIniciales} />
            <section className={styles['areadatosusuario']}>
                <div className={styles['areadatosprospecto']}>
                    <div className={styles['areadatosprospecto__subtitulo']}>
                        <img src={dedoArriba} alt='' />
                        <h2>Firma Electrónica</h2>
                    </div>
                    <div className={styles['areaimagen']}>
                        <img src={modeloFirma} alt='' />
                        {state.codigoEstado === 2 ?
                            <div className={styles['confirmacion']}>
                                <div className={styles['round']}>
                                    <input type="checkbox" id="checkbox" defaultChecked={true} />
                                    <label htmlFor="checkbox"></label>
                                </div>
                                <label className={styles['label-confirmacion']}>Firmado correctamente</label>
                            </div>
                            : state.codigoEstado === 12 ?
                                <div className={styles['confirmacion']}>
                                    <div className={styles['round']}>
                                        <input type="checkbox" id="checkbox" defaultChecked={true} />
                                        <label htmlFor="checkbox"></label>
                                    </div>
                                    <label className={styles['label-confirmacion']}>En proceso de Firma</label>
                                </div>
                                : null
                        }

                    </div>
                </div>
                <FirmaModal
                    state={state}
                    setState={setState}
                    mostrarModal={mostrarModal}
                    setMostrarModal={setMostrarModal}
                    validarPantallaModal={validarPantallaModal}
                    cotizacion={cotizacion}
                />
                <Modal mostrarModal={mostrarMensajes} setModal={setMostrarMensajes} textos={mensajes} />
                <Footer
                    history={history}
                    validarPantalla={validarPantalla}
                    juridico={state.contratante !== null
                        ? state.contratante.tipoPersona.codigo === Constantes.CODIGO_TIPO_PERSONA_JURIDICO
                        : false}
                />
                <Modal mostrarModal={mostrar} setModal={setMostrar} textos={state.textoError} />
            </section>
        </React.Fragment>
    )
}

const FirmaModal = ({ state, setState, mostrarModal, setMostrarModal, validarPantallaModal, cotizacion }) => {
    const handleChangeMail = (event, campo, tipo) => {
        let valor = event.target.value

        if (tipo === 'A') {
            setState((state) => {
                return {
                    ...state,
                    asegurado: {
                        ...state.asegurado,
                        contacto: {
                            ...state.asegurado.contacto,
                            [campo]: valor
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        emailA: true
                    },
                    noBloqueo: false
                }
            })
        } else if (tipo === 'C') {
            setState((state) => {
                return {
                    ...state,
                    contratante: {
                        ...state.contratante,
                        contacto: {
                            ...state.contratante.contacto,
                            [campo]: valor
                        }
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        emailC: true
                    },
                    noBloqueo: false
                }
            })
        } else if (tipo === 'M') {
            setState((state) => {
                return {
                    ...state,
                    aseguradoAdicional:{
                        ...state.aseguradoAdicional,
                        [campo]: valor
                    },
                    campoValidado: {
                        ...state.campoValidado,
                        emailM: true
                    },
                    noBloqueo: false
                }
            })
        }
    }
    return (
        <div>
            <div className={mostrarModal ? `${styles['w3-modal']} ${styles['show-modal-beneficiaries']}` : `${styles['w3-modal']} ${styles['hide-modal-beneficiaries']}`}>
                <div className={styles['w3-modal-content']}>
                    <div className={styles['w3-header']}>
                    </div>
                    <div className={styles['w3-container']}>
                        <p className={styles['w3title']}>
                            Necesitamos una dirección de correo electrónico como tu dirección contractual
                        </p>
                        <div className={`${styles['grupo-de-form']} ${styles['top-18']}`}>
                            <div className={styles['area-50']}>
                                <label>
                                   { state.esAseguradoAdicional ?
                                            <>
                                                A estos correos enviaremos toda la comunicación relacionada a los
                                                seguros que estás solicitando. Por favor, asegúrate de que están
                                                correctamente escritos.
                                            </>
                                        :
                                            <>
                                                A {cotizacion && cotizacion.esDistintoAsegurado ? 'estos correos' : 'este correo'} enviaremos toda la comunicación relacionada a los
                                                seguros que estás solicitando. Por favor, asegúrate de que está
                                                correctamente escrito.
                                            </>
                                   }
                                </label>
                                {
                                    state.estadoFirma == Constantes.ESTADO_FIRMA_CORREO_ERRADO &&
                                    <span className={styles['span-error']}>**Parece que uno o más correos no son válidos. Por favor, verifica e intenta nuevamente.</span>
                                }
                            </div>
                        </div>
                        <div className={styles['area-correo-modal']}>
                            {cotizacion && cotizacion.esDistintoAsegurado ?
                                <div>
                                    <label className={styles['labelCorreo']}>Correo Electrónico Asegurado</label>
                                    <input
                                        type="email"
                                        className={!state.campoValidado.emailA
                                            ? `${styles['logerror']} ${styles['input-corre-modal']}` : styles['input-corre-modal']}
                                        placeholder='Correo Electrónico'
                                        onChange={(e) => handleChangeMail(e, 'email', 'A')}
                                        value={state.asegurado !== null && state.asegurado.contacto !== undefined
                                            ? state.asegurado.contacto.email : ''}
                                        maxLength={60}
                                    />
                                    {!state.campoValidado.emailA &&
                                        <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMAIL}</span>
                                    }
                                    <br /><br />
                                    <label className={styles['labelCorreo']}>Correo Electrónico Contratante</label>
                                </div>
                                :
                                null
                            }
                            {
                                state.esAseguradoAdicional ?
                                    <label className={styles['labelCorreo']}>Correo Electrónico Asegurado Principal</label>
                                : null
                            
                            }
                            <input
                                type="email"
                                className={!state.campoValidado.emailC
                                    ? `${styles['logerror']} ${styles['input-corre-modal']}` : styles['input-corre-modal']}
                                placeholder='Correo Electrónico'
                                onChange={(e) => handleChangeMail(e, 'email', 'C')}
                                value={state.contratante !== null && state.contratante.contacto !== undefined
                                    ? state.contratante.contacto.email : ''} 
                                maxLength={60}
                            />
                            
                            {!state.campoValidado.emailC &&
                                <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMAIL}</span>
                            }
                            {state.campoValidado.emailCA !== undefined && !state.campoValidado.emailCA &&
                                <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMAIL_REPETIDO}</span>
                            }

                            {
                                state.esAseguradoAdicional ?
                                    <div>
                                        <br/>
                                        <label className={styles['labelCorreo']}>Correo Electrónico Asegurado Adicional</label>
                                        <input
                                            type="email"
                                            className={!state.campoValidado.emailM
                                                ? `${styles['logerror']} ${styles['input-corre-modal']}` : styles['input-corre-modal']}
                                            placeholder='Correo Electrónico'
                                            onChange={(e) => handleChangeMail(e, 'correoElectronico', 'M')}
                                            value={state.aseguradoAdicional !== null && state.aseguradoAdicional !== undefined
                                                ? state.aseguradoAdicional.correoElectronico : ''}
                                            maxLength={60}
                                        />
                                        {!state.campoValidado.emailM &&
                                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMAIL}</span>
                                        }
                                        {state.campoValidado.emailCM !== undefined && !state.campoValidado.emailCM &&
                                            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_EMAIL_REPETIDO}</span>
                                        }
                                    </div> 
                                : null
                            }
                        </div>
                        <div className={styles['w3areabtn']}>
                            <button className={`${styles[state.contratante !== null ? 'btn-pago-accion' : 'btn-pago-no-accion']}`}
                                onClick={state.contratante !== null ? validarPantallaModal : null}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Firma